module.exports = __webpack_public_path__ + "img/map_6.b43d83fe.webp";